import React, { Component } from 'react'
// import { connect } from 'react-redux'

import Button from '../button'
import Icon from '../icon'
import { ButtonIcons } from '../icons'

import './arrowbutton.scss'
class ArrowButton extends Component {
  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    let buttonProps = { ...this.props }
    let icon = null
    switch (this.props.size) {
      case 's':
        icon = ButtonIcons.Arrow_Link_16
        break
      case 'm':
        icon = ButtonIcons.Arrow_Link_20
        break
      case 'l':
        icon = ButtonIcons.Arrow_Link_24
        break
    }

    let rotation = 0
    switch (this.props.dir) {
      case 'left':
      case 'l':
        rotation = 180
        break
      case 'right':
      case 'r':
        rotation = 0
        break
      case 'top':
      case 't':
        rotation = 270
        break
      case 'down':
      case 'd':
        rotation = 90
        break
    }

    return (
      <div className='element-arrowbutton'>
        <Button {...buttonProps}>
          <Icon size={this.props.size} icon={null} icon2={icon} injectSvg rotation={rotation} />
        </Button>
      </div>
    )
  }
}

ArrowButton.defaultProps = {
  size: 'l',
  style: 'link',
  round: true,
  spacing: 0,
  dir: 'right'
}

ArrowButton.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default ArrowButton



// WEBPACK FOOTER //
// ./src/app/shared/elements/arrowButton/index.js